import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';

@NgModule({
  declarations: [
    MaintenanceComponent,
    MaintenanceBannerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    MaintenanceBannerComponent,
  ],
})
export class MaintenanceModule {}
